<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <div class="col-lg-6 col-xs-12 col-xl-6 col-md-12">
                            <p class="page-text margin-bottom-20 margin-top-0">
                                Gerencie o mural de recados, ele aparece para os pacientes na tela inicial do aplicativo.
                            </p>
                        </div>                        
                        <div class="col-xl-12">

                            <a class="button transparent margin-bottom-15" v-on:click="mostrarCadastro = (!mostrarCadastro ? true : false);">
                                <i v-if="!mostrarCadastro" class="las la-chevron-down"></i>
                                <i v-if="mostrarCadastro" class="las la-chevron-up"></i>
                                Adicionar recado
                            </a>                                  

                            <form v-show="mostrarCadastro" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="submit">
                                <div class="row">
                                    <div class="col-lg-12 col-xs-12 col-xl-12 col-md-10">
                                        <div class="submit-field" style="margin-bottom: 0px">
                                            <h5>Adicionar recado:</h5>
                                            <textarea class="with-border margin-bottom-0" v-model="form.objeto.conteudo" placeholder="Escreva aqui..."></textarea>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 margin-top-10"></div>
                                    <div class="col-lg-12 col-xs-12 col-xl-12 col-md-10">
                                        <div class="submit-field" style="margin-bottom: 10px !important">
                                            <h5>Mostrar recado para:</h5>
                                        </div>
                                    </div>    

            
                                    <div class="col-xs-12"></div>
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-contratante" v-model="form.objeto.destinatarios" :value="'contratante'">
                                            <label for="mural-destinatarios-contratante"><span class="checkbox-icon"></span> Pacientes</label>
                                        </div>                                    
                                    </div>      
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-profissional" v-model="form.objeto.destinatarios" :value="'profissional'">
                                            <label for="mural-destinatarios-profissional"><span class="checkbox-icon"></span> Profissionais</label>
                                        </div>                                    
                                    </div>      
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-marketing" v-model="form.objeto.destinatarios" :value="'marketing'">
                                            <label for="mural-destinatarios-marketing"><span class="checkbox-icon"></span> Marketing</label>
                                        </div>                                    
                                    </div>      
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-criacao" v-model="form.objeto.destinatarios" :value="'criacao'">
                                            <label for="mural-destinatarios-criacao"><span class="checkbox-icon"></span> Criação</label>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-controladoria" v-model="form.objeto.destinatarios" :value="'controladoria'">
                                            <label for="mural-destinatarios-controladoria"><span class="checkbox-icon"></span> Controladoria</label>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-gerente" v-model="form.objeto.destinatarios" :value="'gerente'">
                                            <label for="mural-destinatarios-gerente"><span class="checkbox-icon"></span> Gerente</label>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-coordenador" v-model="form.objeto.destinatarios" :value="'coordenador'">
                                            <label for="mural-destinatarios-coordenador"><span class="checkbox-icon"></span> Coordenador</label>
                                        </div>
                                    </div>    
                                    <div class="col-xs-6 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg "></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="mural-destinatarios-admin" v-model="form.objeto.destinatarios" :value="'admin'">
                                            <label for="mural-destinatarios-admin"><span class="checkbox-icon"></span> Administrador</label>
                                        </div>
                                    </div>                                                                                                                                                
                                    <div class="col-xl-12 clearfix">
                                        <hr>
                                    </div>
                                    <div class="col-xs-8 col-xl-3 ">
                                        <div class="hidden-xl hidden-lg padding-top-12"></div>
                                        <div class="checkbox">
                                            <input type="checkbox" id="lembrete-agendamento-push" v-model="form.objeto.pushEnviar" true-value="1" false-value="0">
                                            <label for="lembrete-agendamento-push"><span class="checkbox-icon"></span> Enviar notificação push</label>
                                        </div>                                    
                                    </div>

                                    <div class="col-lg-12 col-md-3 col-xl-12 col-xs-12">
                                        <div class="submit-field">
                                            <div class="margin-top-10"></div>
                                            <!-- <div class="hidden-xs clearfix" style="margin-top: 32px;"></div> -->
                                            <button class="button small color-secondary big block-mobile">
                                                <i class="las la-save"></i>
                                                Salvar recado
                                            </button>                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-40"></div>
                            </form>                           
                        </div>
                        <div class="col-lg-12">                        
                            <div class="dashboard-box margin-top-0 cards">
                                <div class="content">
                                    <h5 class="block-title">
                                        <i class="las la-info-circle"></i>
                                        Mural ativo
                                    </h5>
                                    <h5 v-if="itens.habilitados.length == 0 && data.loaded" class="empty margin-bottom-20">
                                        <i class="las la-times"></i>                                          
                                        Nenhum resultado encontrado.
                                    </h5>                                    
                                    <ul class="dashboard-box-list" style="flex-direction: column;" v-show="itens.habilitados.length > 0">
                                        <li v-for="(item, index) in itens.habilitados" style="padding: 0px;">
                                            <a class="job-listing card2">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description" style="padding-top: 0px;">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <p v-show="formEditar.cod != item.cod" style="line-height: 110%; padding-top: 0px; margin-top: 3px;" class="margin-bottom-10" v-html="item.objeto.conteudo.replace(/(?:\r\n|\r|\n)/g, '<br>')">
                                                                    
                                                                </p>
                                                                <textarea v-model="formEditar.objeto.conteudo" v-show="formEditar.cod == item.cod" style=""></textarea>
                                                                
                                                            </div>

                                                        
                                                            <div class="col-xs-12" v-if="formEditar.cod == item.cod">
                                                                <div class="row margin-bottom-10">
                                                                    <div class="col-lg-12 col-xs-12 col-xl-12 col-md-10">
                                                                        <div class="submit-field" style="margin-bottom: 10px !important;">
                                                                            <h5 style="font-weight: 400;">Mostrar recado para:</h5>
                                                                        </div>
                                                                    </div>    
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-contratante-' + index" v-model="item.objeto.destinatarios" :value="'contratante'">
                                                                            <label :for="'mural-destinatarios-contratante-' + index"><span class="checkbox-icon"></span> Pacientes</label>
                                                                        </div>                                    
                                                                    </div>      
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-profissional-' + index" v-model="item.objeto.destinatarios" :value="'profissional'">
                                                                            <label :for="'mural-destinatarios-profissional-' + index"><span class="checkbox-icon"></span> Profissionais</label>
                                                                        </div>                                    
                                                                    </div>      
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-marketing-' + index" v-model="item.objeto.destinatarios" :value="'marketing'">
                                                                            <label :for="'mural-destinatarios-marketing-' + index"><span class="checkbox-icon"></span> Marketing</label>
                                                                        </div>                                    
                                                                    </div>      
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-criacao-' + index" v-model="item.objeto.destinatarios" :value="'criacao'">
                                                                            <label :for="'mural-destinatarios-criacao-' + index"><span class="checkbox-icon"></span> Criação</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-controladoria-' + index" v-model="item.objeto.destinatarios" :value="'controladoria'">
                                                                            <label :for="'mural-destinatarios-controladoria-' + index"><span class="checkbox-icon"></span> Controladoria</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-gerente-' + index" v-model="item.objeto.destinatarios" :value="'gerente'">
                                                                            <label :for="'mural-destinatarios-gerente-' + index"><span class="checkbox-icon"></span> Gerente</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-coordenador-' + index" v-model="item.objeto.destinatarios" :value="'coordenador'">
                                                                            <label :for="'mural-destinatarios-coordenador-' + index"><span class="checkbox-icon"></span> Coordenador</label>
                                                                        </div>
                                                                    </div>    
                                                                    <div class="col-xs-6 col-xl-3 ">
                                                                        <div class="hidden-xl hidden-lg "></div>
                                                                        <div class="checkbox">
                                                                            <input type="checkbox" :id="'mural-destinatarios-admin-' + index" v-model="item.objeto.destinatarios" :value="'admin'">
                                                                            <label :for="'mural-destinatarios-admin-' + index"><span class="checkbox-icon"></span> Administrador</label>
                                                                        </div>
                                                                    </div>   
                                                                </div>        
                                                            </div>

                                                            <div class="col-lg-12">
                                                                <div style="line-height: 20px;">
                                                                    <small v-if="item.objeto.pushEnviar == 1">
                                                                        <i class="las la-bell"></i>
                                                                        Notificação push
                                                                        <br>
                                                                    </small>                                                                    
                                                                    <small>
                                                                        <i class="las la-eye"></i>
                                                                        Visível para: 

                                                                        <span v-if="!item.objeto.destinatarios">Todos</span>
                                                                        <span v-if="item.objeto.destinatarios"><span v-if="item.objeto.destinatarios.length == 0">Todos</span></span>

                                                                        <span v-for="(item2, index) in item.objeto.destinatarios" class="dashboard-status-button color-orange" style="font-size: 10px; padding: 0px 5px; line-height: 120%">
                                                                            {{item2 == 'admin' ? 'Administrador' : ''}}
                                                                            {{item2 == 'contratante' ? 'Paciente' : ''}}
                                                                            {{item2 == 'marketing' ? 'Marketing' : ''}}
                                                                            {{item2 == 'profissional' ? 'Profissional' : ''}}
                                                                            {{item2 == 'gerente' ? 'Gerente' : ''}}
                                                                            {{item2 == 'coordenador' ? 'Coordenador' : ''}}
                                                                            {{item2 == 'controladoria' ? 'Controladoria' : ''}}
                                                                            {{item2 == 'criacao' ? 'Criação' : ''}}
                                                                        </span>
                                                                    </small>
                                                                    <br>    
                                                                    <small>
                                                                        <i class="las la-user"></i>
                                                                        Criado por: {{item.usuario.nome}}
                                                                    </small>
                                                                    <br>                                                                
                                                                    <small>
                                                                        <i class="las la-clock"></i>
                                                                        Criado em: {{item.datahora | formatDate}}
                                                                    </small>                      
                                                                </div>  
                                                                <div style="height: 30px"></div>
                                                                <div class="buttons" >
                                                                    <button v-if="formEditar.cod == item.cod" v-on:click.prevent="submitEditar()" type="button" class="dashboard-status-button green">
                                                                        <i class="las la-edit"></i> Salvar alterações
                                                                    </button>
                                                                    <button v-if="formEditar.cod == item.cod" v-on:click.prevent="editar(null)" type="button" class="dashboard-status-button red">
                                                                        <i class="las la-times"></i> Cancelar
                                                                    </button>   
                                                                    <button v-if="formEditar.cod != item.cod" v-on:click.prevent="editar(item)" type="button" class="dashboard-status-button gray">
                                                                        <i class="las la-edit"></i> Editar
                                                                    </button>
                                                                    <button v-if="formEditar.cod != item.cod" v-on:click.prevent="del(item.cod, 'desabilitar')" type="button" class="dashboard-status-button gray">
                                                                        <i class="las la-times"></i> Desativar
                                                                    </button>                                                    
                                                                </div>                                                                 
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>                                        
                                    </ul>
                                </div>
                            </div>                               
                        </div> 
                        <div class="col-lg-12">                        
                            <div class="dashboard-box margin-top-0 cards">
                                <div class="content">
                                    <h5 class="block-title">
                                        <i class="las la-info-circle"></i>
                                        Desativados
                                    </h5>
                                    <h5 v-if="itens.desativados.length == 0 && data.loaded" class="empty">
                                        <i class="las la-times"></i>                                          
                                        Nenhum resultado encontrado.
                                    </h5>                                       
                                    <ul class="dashboard-box-list" style="flex-direction: column;" v-show="itens.desativados.length > 0">
                                        <li v-for="(item, index) in itens.desativados" style="padding: 0px;">
                                            <a class="job-listing card2">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description" style="padding-top: 0px;">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <p v-show="formEditar.cod != item.cod" style="line-height: 110%; padding-top: 0px; margin-top: 3px;" class="margin-bottom-10" v-html="item.objeto.conteudo.replace(/(?:\r\n|\r|\n)/g, '<br>')">
                                                                </p>
                                                                <textarea v-model="formEditar.objeto.conteudo" v-show="formEditar.cod == item.cod"></textarea>
                                                                <div style="line-height: 20px;">
                                                                    <small v-if="item.objeto.pushEnviar == 1">
                                                                        <i class="las la-bell"></i>
                                                                        Notificação push
                                                                        <br>
                                                                    </small>
                                                                    <small>
                                                                        <i class="las la-user"></i>
                                                                        {{item.usuario.nome}}
                                                                    </small>
                                                                    <br>                                                                
                                                                    <small>
                                                                        <i class="las la-clock"></i>
                                                                        {{item.datahora | formatDate}}
                                                                    </small>                      
                                                                </div>  
                                                                <div style="height: 30px"></div>
                                                                <div class="buttons">
                                                                    <button v-if="formEditar.cod == item.cod" v-on:click.prevent="submitEditar()" type="button" class="dashboard-status-button green">
                                                                        <i class="las la-edit"></i> Salvar alterações
                                                                    </button>    
                                                                    <button v-if="formEditar.cod == item.cod" v-on:click.prevent="editar(null)" type="button" class="dashboard-status-button red">
                                                                        <i class="las la-times"></i> Cancelar
                                                                    </button>                                                                                                                                    
                                                                    <button v-if="formEditar.cod != item.cod" v-on:click.prevent="ativar(item.cod)" type="button" class="dashboard-status-button gray ">
                                                                        <i class="material-icons">check_circle</i> Ativar
                                                                    </button>
                                                                    <button v-if="formEditar.cod != item.cod" v-on:click.prevent="editar(item)" type="button" class="dashboard-status-button gray ">
                                                                        <i class="las la-edit"></i> Editar
                                                                    </button>
                                                                    <button v-if="formEditar.cod != item.cod" v-on:click.prevent="del(item.cod)" type="button" class="dashboard-status-button gray ">
                                                                        <i class="las la-trash"></i> Apagar
                                                                    </button>                     
                                                                </div>                                                                 
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>                               
                        </div>                          
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Mural',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        nl2br: function(str) {
            return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "mostrarCadastro":      false,
            "data":                 {
                "itens":            []
            },          
            "itens":                {
                "habilitados":      [],
                "desativados":      []
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             "mural",
                "habilitado":       1,
                "objeto": {
                    "pushEnviar":       1,
                    "pushTexto":        "",
                    "pushTitulo":       "",
                    "agendamento":      0,
                    "conteudo":         "",
                    "destinatarios":    [],
                    "data":             "",
                    "hora":             ""
                }                
            },
            "formEditar": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             "mural",
                "habilitado":       0,
                "objeto": {
                    "pushEnviar":       1,
                    "pushTexto":        "",
                    "pushTitulo":       "",
                    "agendamento":      0,
                    "conteudo":         "",
                    "data":             "",
                    "destinatarios":    [],
                    "hora":             ""
                }                
            },            
        }
    },
    watch: {
                  
    },
    methods: {              
        ativar: function(cod) {
            var self            = this;
            console.log("ativar()");
            
            loading.show();
                
            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "cod":          cod,
                "acao":         "habilitar"
            };

            axios.put("api/mural.php", form)
            .then(response => {
                
                console.log("ativar() response", response)

                self.get().then(function() {
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("ativar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        editar: function(item) {
            console.log("editar()", item)
            var self = this;
            if (item == null) {
                self.formEditar.id = "";
                self.formEditar.cod = "";
                self.$forceUpdate();
                return false;
            }

            if (!item.objeto.destinatarios) {
                item.objeto.destinatarios = [];
            }

            self.formEditar.id          = item.id;
            self.formEditar.cod         = item.cod;
            self.formEditar.nome        = item.nome;
            self.formEditar.notificacaoCod = item.notificacaoCod;
            self.formEditar.habilitado  = item.habilitado;
            self.formEditar.objeto      = item.objeto;

            self.$forceUpdate();
        },
        submitEditar: function() {
            var self            = this;
            console.log("submitEditar()", self.formEditar);
            
            loading.show();
                
            axios.put("api/mural.php", self.formEditar)
            .then(response => {
                
                console.log("submitEditar() response", response)
                self.formEditar.id  = "";
                self.formEditar.cod = "";
                self.get().then(function() {
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("submitEditar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        submit: function() {
            var self            = this;
            console.log("submit()", self.form);
            
            loading.show();
                
            axios.put("api/mural.php", self.form)
            .then(response => {
                
                console.log("submit() response", response)

                self.form.objeto.conteudo       = "";
                self.form.objeto.destinatarios  = [];
                self.form.objeto.pushEnviar     = 0;

                self.get().then(function() {
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        del: function(cod, acao) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = acao || null;
                loading.show();
                
                axios.delete("api/mural.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });                 
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },             
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         "mural",
                        "multiplo":     true
                    }
                };

                axios.get("api/mural.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data               = response.data.result;
                    self.itens.habilitados  = [];
                    self.itens.desativados  = [];

                    response.data.result.itens.forEach(function(item) {
                        if (item.habilitado == 1) {
                            self.itens.habilitados.push(item);
                        } else {
                            self.itens.desativados.push(item);
                        }
                    })

                    self.$forceUpdate();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    textarea {
        min-height: 100px; 
        padding: 10px; 
        line-height: 120%;      
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 0px;
        left: 5px;
        padding-top: 30px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
    }
    .dashboard-status-button i {
        /*color: #fff;*/
        display: inline-block !important;
        top: 1px;
        margin-top: 0px;
    }    
</style>



// WEBPACK FOOTER //
// src/components/Mural.vue